import AbstractRequestTask from "../../AbstractRequestTask";
import {ENABLE_MODAL_RETRIES} from '../../../RequestManagerConstants';
import Device from "../../../../devices/device";

class userTask extends AbstractRequestTask {
  constructor(params) {
    super();
    this.gamificationId = params.gamificationId;
  }

  getHeaders() {
    return {};
  }

  getParams() {
    return { }
  }

  getUrl() {
    const device = Device.getDevice().getPlatform()
    const protocol = device === 'ps4' ? 'http://' : 'https://';
    const url = 'www.clarovideo.com';
    return `${protocol}${url}/api/social/user/${this.gamificationId}`;
  }

  success(data, b) {
      return this.resolve(data);
  }

  isValid (data){
      return data && data.status == true || false;
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
  
}

export default userTask;


// WEBPACK FOOTER //
// ./src/requests/tasks/social/user/userTask.js